
import React, { Component } from 'react'
import { connect } from 'react-redux';

import { Grid, Hidden, IconButton, Paper } from '@material-ui/core';

class MultipleDeleteModal extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
        };
    }

    render() {
        return (
            <>
                <Grid>
                    <Paper elevation={3} className="batchDeleteModalPaper" square='false' color='secondary'>
                        <Grid item container xs={12} justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >

                            {/* Close Icon */}
                            <Grid item container xs={12} justifyContent='flex-end' style={{height:'5%'}}>
                                <IconButton onClick={()=>this.props.close()}>
                                    <img
                                        src='https://engage360.s3.amazonaws.com/Icons/circle-xmark.svg'
                                        alt='close'
                                        style={{color:'white'}}
                                        height="35px"
                                    />
                                </IconButton>
                            </Grid>
                            {/* Title*/}
                            <Grid item container alignItems='center' className="TitleRepairsModal">{`Are you sure you want to delete the following ${this.props.selectAll?this.props.totalDinings: this.props.dinings.length} menu items?`}</Grid>
                            
                            <Grid item container className="batchDeleteContainer">

                                {/* Dinings Titles */}
                                <Hidden smDown>
                                <Grid container className="titleEngageStyleHeadersBook"  justify='center' alignItems='center' style={{height:'10%', marginTop:'.5rem'}}>
                                    <Grid id="id_dining_header_list_image" item md={2} style={{ textAlign: 'center' }} >Image</Grid>
                                    <Grid id="id_dining_header_list_menu_item" item md={5}>
                                        Menu Item
                                    </Grid>
                                    <Grid id="id_dining_header_list_meal" item md={2}>
                                        Meal
                                    </Grid>
                                    <Grid id="id_dining_header_list_date_serve" item md={3}>
                                        Date Served
                                    </Grid>
                                </Grid>
                                </Hidden>

                                {/* Dinings Info */}                                
                                <Grid item container xs={12} justifyContent='center' alignItems='flex-start' style={{minHeight:'40%', maxHeight:'50%', overflowY:'scroll', marginTop:'.5rem'}}>
                                    {
                                        (this.props.dinings) &&
                                            this.props.dinings.map((d,index)=>{
                                                return(
                                                    <Grid container xs={12} key={d._id} justify='center' alignItems='center' className="rowEngageStyleList" id={`dining_row_${d._id}`}
                                                        style={{backgroundColor:'black'}}
                                                    >
                                                        <Grid item container justifyContent='center' alignItems='center' xs={12} sm={12} md={2}>
                                                            <img
                                                                alt={'Image' + index}
                                                                style={{ borderRadius: '10px', alignContent: 'center', objectFit:'cover' }}
                                                                width='80px'
                                                                height='55px'
                                                                src={d.imageUrl?d.imageUrl:''}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={12} md={5} className="rowEngageStyle rowEngageStyleLeft" >{d.name}</Grid>
                                                        <Grid item xs={12} sm={12} md={2} className="rowEngageStyle rowEngageStyleLeft" >{this.props.getMealType(d.type)}</Grid>
                                                        <Grid item xs={12} sm={12} md={3} className="rowEngageStyle rowEngageStyleLeft" >{this.props.getTime(d, this.props.timeZoneName)}</Grid>
                                                    </Grid>
                                                )
                                            })
                                    }
                                </Grid>

                                <Grid item container alignItems='center' className="titleEngageStyleHeadersBook" style={{height:'20%', paddingTop:'10px', paddingBottom:'10px'}}>
                                    For recurring menu items, this will delete only the occurrence(s) selected. To delete all instances of a recurring menu item, open an instance of a menu item and you will have the option to delete only the selected occurrence or all occurrences. 
                                </Grid>


                                {/* Buttons */}
                                
                                <Grid item container className="alingCenter" justifyContent='flex-end'style={{height:'20%'}}>
                                    <Grid item container xs={5} md={4} lg={3} style={{ marginRight:'10px'}}  className="VoiceSettingModalButtonCancel alingCenter" onClick={() => this.props.close()}>
                                        No, Cancel
                                    </Grid>

                                    <Grid item container xs={5} md={4} lg={3} className="VoiceSettingModalButtonYes alingCenter"  onClick={()=>this.props.delete()}>
                                        Yes, Delete
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </>
        )
    }
}

function mapStateToProps(state, dispatch) {
    let diningData = (state.diningReducer && state.diningReducer.diningData) ? state.diningReducer.diningData : [];

    return {
        diningData
    }
}


export default connect(mapStateToProps, {})(MultipleDeleteModal);

